/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'region': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _stroke="#FFF" stroke-opacity=".8" d="M2 13h2v2H2v-2zM1 7h2v2H1V7zm5-3h2v2H6V4zm6-3h2v2h-2V1zm1 8h2v2h-2V9zm-4 5h2v2H9v-2z"/><path pid="1" _fill="#FFF" fill-opacity=".8" d="M11.5 2.191l-3 1.5v1.118l3-1.5V2.191zM12.684 3.5l.625 5h1.007l-.625-5h-1.007zm-2.124 10l1.94-2.425v.425h.94l-1.94 2.425V13.5h-.94zm-2.06.78l-4-.57v1.01l4 .57v-1.01zm-3-7.797V5.317l-2 1.2v1.166l2-1.2zM1.743 9.5l.5 3h1.014l-.5-3H1.743z"/></g>'
  }
})
